import React, { FC } from "react";
import NcdcRequestProgress from "./NcdcRequestProgress";
import classNames from "classnames";
import {useForm} from "react-hook-form";

type Props = {
    page: number;
    getPage: (seq: number) => void;
    getData: (data: any) => void;
}

const NcdcRequestUser: FC<Props> = ({page, getPage, getData}) => {
    const goToPrev = () => {
        window.scrollTo(0, 0);
        getPage(page - 1);
    }

    const goToNext = () => {
        window.scrollTo(0, 0);
        getPage(page + 1);
    }

    const { register, handleSubmit } = useForm();
    const onSubmit = (data: any) => {
        window.scrollTo(0, 0);
        getPage(page + 1);
        getData(data);
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>

        <div className={classNames('ncdc-request-form-wrapper', {'no-show': page !== 4})}>
            <div className={'ncdc-request-form'}>
                <div className={'common-form-header-wrapper'}>
                    <span className={'common-form-header-title'}>데이터 신청</span>
                    <div className={'common-form-header-circle'} />
                </div>
                <NcdcRequestProgress seq={page - 1} />
                <div className={'common-form-table-wrapper'}>
                    <div className={'common-form-table'}>
                        <div className={'common-form-table-header-wrapper'}>
                            <div className={'common-form-table-header-title'}>
                                연구원 등록
                            </div>
                        </div>
                        <div className={'common-form-table-body-wrapper'}>
                            <div className={'common-form-table-body'}>
                                <label>
                                    <span className={'common-form-input-label'}>
                                        과제책임자
                                        <span className={'common-form-input-label-alert'}>*</span>
                                    </span>
                                    <input className={'common-form-input-text lg'} />
                                </label>
                                <label className={'last'}>
                                    <span className={'common-form-input-label'}>
                                        <select className={'common-form-input-select label'}>
                                            <option value={'select'}>선택</option>
                                            <option value={'coworker'}>공동연구원</option>
                                            <option value={'assistant'}>보조</option>
                                        </select>
                                    </span>
                                    <input className={'common-form-input-text lg'} />
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'common-form-table-addon'}>+ 연구원 추가</div>
                <div className={'common-form-table-wrapper'}>
                    <div className={'common-form-table'}>
                        <div className={'common-form-table-header-wrapper'}>
                            <div className={'common-form-table-header-title'}>
                                이용약관 동의
                            </div>
                        </div>
                        <div className={'common-form-term-wrapper'}>
                            <div className={'common-form-term'}>
                                <textarea className={'common-form-term-textarea'} />
                                <label>
                                    <input type={'checkbox'} />
                                    <span>위 약관에 동의합니다.</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'common-form-button-wrapper'}>
                    <div>
                        <button className={'common-button light'} onClick={goToPrev}>이전</button>
                    </div>
                    <div>
                        <button className={'common-button light'}>임시저장</button>
                        <button className={'common-button primary ml-10'} onClick={goToNext}>다음</button>
                    </div>
                </div>
            </div>
        </div>
        </form>
    );
}

export default NcdcRequestUser;
